//var filterCats = new Object();
var propsPerPage = 15;
var items = [];
//var states = [];
//var luxCats = [];
var totalPages;
//var locCats = [];
//var totalProps;
//var property;
var properties = [];
var propertiesShow = [];
//var autoCompCat = ['property_name','state_name','country_name','city','name'];
var initCount = true;
//var autocomp = false;
//var query;

const filtering = {
  init() {
    this.filterProperty();
    this.filterExperience();
  },

  filterProperty() {
    $('#property-filter').change(function() {
      $('a#show-package-link').show();
      var theFilter = $(this).val();
      filtering.packageFilter('property', theFilter);
      filtering.totalPropsHandler();	
    });
  },

  filterExperience() {
    $('#experience-filter').change(function() {
      $('a#show-package-link').show();
      var curProp = $(this).val();
      filtering.experienceFilter(curProp);
      filtering.totalPropsHandler();					  										  
    });
  },
  
  packageFilter(newfilterid, theFilter) {
    $('#property-filter-wrapper div.property-filter').each(function() {
      if( !($(this).hasClass(theFilter)) && theFilter!='' ) {
        $(this).removeClass('active');
        $(this).hide();
      } else {
        $(this).addClass('active');
        $(this).show();	
      }
    });		
  },
  
  experienceFilter(theFilter) {
    $('#property-filter-wrapper div.property-filter').each(function() {
      if ( !($(this).hasClass(theFilter)) ) {
        $(this).removeClass('active');
        $(this).hide();
      } else {
        $(this).addClass('active');
				$(this).show();	
      }
    });		
  },
  
  totalPropsHandler() {
    var totalProps = $('.property-listing').find('.active').length;
    if (totalProps > 0) {
      var searchMsg = '<p><p>Your search returned <span id="result-count">' + totalProps + '</span> results.</p>';
      $('div#num-results').html(searchMsg).show();
      $('div#no-results').hide();
    } else {
      $('div#num-results').hide();
      $('div#no-results').show();
      $('.next-page').hide();
      $('.prev-page').hide();
    }
    totalPages = Math.ceil( totalProps/propsPerPage);
    filtering.createNavigationResults(totalPages);
    //filtering.setDataAndEventsResults(totalPages);
    //$('div#loading-overlay').hide();
    //$('div#loading-wrapper').hide();
  },
  
  createNavigationResults(totalPages) {
    var navHTML = '';
    for (var i = 0; i < totalPages; i++) {
      navHTML += '<li class="'+(i+1)+'"><a href="#pages-wrapper">'+(i+1)+'</a></li>';
    }
    if (totalPages >1) 
      $('.results-pagination').html(navHTML);
    else
      $('.results-pagination').html('');
      $('.prev-page').hide();
	
      filtering.goToPageResults(1, totalPages);
	
    // need to rewrite to use links instead of select
    $('.resultsNav li a').on('click',function() {
      if($(this).parent().parent().parent().hasClass('pages-wrapper-bottom')) {
        window.scrollTo(0,$("#pages-wrapper").offset().top); 	
      }
      filtering.goToPageResults($(this).parent().attr('class'), totalPages);
      return false;
    });
  },
  
  setDataAndEventsResults(propsPerPage) {
    $('.property-listing').data('currentPage',1);
    if ( $('.property-listing').attr('id')=='property-listing' )
      $('.property-listing li.active:gt(' + (propsPerPage-1) + ')').hide();
    else
      $('.property-listing div.property-filter.active:gt(' + (propsPerPage-1) + ')').hide();
  },
  
  goToPageResults(pageNumber, totalPages) {
    var currentPage = parseInt(pageNumber);
    pageNumber = pageNumber.toString();
    pageNumber = pageNumber.replace(" current","");
    propsNoFeatured;
    $('.results-pagination li').removeClass('current');			
    if (pageNumber == 1) $('.previous-page').hide();	else $('.previous-page').show();					
    if ((pageNumber == totalPages) || (totalPages==0)) $('.next-page').hide(); else $('.next-page').show();
    $('.results-pagination li.'+pageNumber).addClass('current');
    $('.property-listing').data('currentPage', pageNumber);
    $('#goTo').val(pageNumber);
	
    //Each special offers page may have varying numbers of featured offers
    //Each page should still show a maximum number of offers are orignially specified in propsPerPage
    //All featured offers should remain visible on all pages.
    var featuredCount = $('.featured').length;
    if(pageNumber > 1){
      var propsNoFeatured = propsPerPage - featuredCount
    } else { 
      propsNoFeatured = propsPerPage;
    }
    var from = (pageNumber - 1) * propsNoFeatured;
    var to = from + (propsNoFeatured - 1);
    if(pageNumber > 1){
      from = from  + featuredCount;
      to = to + featuredCount;
    }
	
    if ( $('.property-listing').attr('id')=='property-listing' ) {
      $('.property-listing li.active').show();
      $('.property-listing li.active:lt(' + (from) + ')').not(".featured").hide();
      $('.property-listing li.active:gt(' + (to) + ')').not(".featured").hide();
      $('.results-pagination li').show();
      $('.results-pagination').each(function(){
        $('li:lt(' + (currentPage-3) + ')',this).hide();
        $('li:gt(' + (currentPage+1) + ')',this).hide();
      });
		
    } else {
      $('.property-listing div.property-filter.active').show();
      $('.property-listing div.property-filter.active:lt(' + (from) + ')').not(".featured").hide();
      $('.property-listing div.property-filter.active:gt(' + (to) + ')').not(".featured").hide();
      $('.results-pagination li').show();
      $('.results-pagination').each(function(){
        $('li:lt(' + (currentPage-3) + ')',this).hide();
        $('li:gt(' + (currentPage+1) + ')',this).hide();
      });
    }
    filtering.updateFilterCount();
  },
  
  updateFilterCount() {
    if(properties[0]!='initialize') {
      $('.filter-group').each(function() {
        if ( $(this).children().children().hasClass('filter-count') ) {
          var filterCount = $(this).children().children('.filter-count');
          var filterType = $(this).children().children('.filter-count').attr('id').substr(7).replace('-','_');
          if ( !$(filterCount).children('li').hasClass('active') || initCount == true ) {
            $(filterCount).children('li').each(function(){ 
              var updateID = $(this).children().attr('filter');
              var updateSpan = $(this).children().children('span');
              var count = 0;
              $.each(propertiesShow,function(k){											   												   
                var curPropertyItem = propertiesShow[k];
                if( (typeof(curPropertyItem)!='object')&&(typeof(curPropertyItem)!=undefined) ) {	
                  var curPropertyFiltType = items[curPropertyItem][filterType];
                  var filtTypes = curPropertyFiltType.split(",");
                  if(items[curPropertyItem][filterType]==updateID) {
                    count++;	
                  } else {
                    $.each(filtTypes, function(key, value) { 
                      if ( value == updateID ){
                        count++;
                      }
                    });								
                  }
                } else if(curPropertyItem['property_name']!=undefined){
                  curPropertyFiltType = curPropertyItem[filterType];
                  /*var curPropertyFiltType = items[curPropertyItem][filterType];*/
                  filtTypes = curPropertyFiltType.split(",");
                  if(curPropertyFiltType==updateID) {
                    count++;	
                  } else {
                    $.each(filtTypes, function(key, value) { 
                      if ( value == updateID ){
                        count++;
                      }
                    });
                  }								
                }
              });
              $(updateSpan).html(count);
            }); 
          }
        }
      });
    }
    initCount = false;
  },

  
  

};

filtering.init();
